<template>
  <div id="anchor">
    <div id="toTop" class="anchor_item" @click="goTop">
      <img class="img1" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/zhiding.png" alt="">
      <img class="img2" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/zhiding_a.png" alt="">
    </div>
    <div class="anchor_item">
      <img class="img1" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/kefu.png" alt="">
      <img class="img2" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/kefu_a.png" alt="">
      <div class="tel">
        <p>客服电话</p>
        <p>4001-368-360</p>
        <div class="arrow"></div>
      </div>
    </div>
    <div class="anchor_item">
      <img class="img1" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/xiazai.png" alt="">
      <img class="img2" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/xiazai_a.png" alt="">
      <div class="download">
        <div class="arrow"></div>
        <div class="download_item" style="margin-top: 0;">
          <span>ios货主端</span>
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/i_hz4.png" alt="">
        </div>
        <div class="download_item">
          <span>Android货主端</span>
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/a_hz.png" alt="">
        </div>
        <div class="download_item">
          <span>ios司机端</span>
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/i_sj.png" alt="">
        </div>
        <div class="download_item">
          <span>Android司机端</span>
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/home/a_sj.png" alt="">
        </div>
      </div>
    </div>
    <div id="toBot" class="anchor_item" @click="goBot">
      <img class="img1" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/xiala.png" alt="">
      <img class="img2" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/xiala_a.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "fix-anchor",
  props: ['box'],
  data() {
    return{

    }
  },
  methods: {
    /**
     * @description: 页面滚动到底部
     * @author: 书童
    */
    goBot() {
      console.log('打印了')
      this.$emit('goBottom')
      // let top = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(document.body.height);
      // // 实现滚动效果
      // const timeTop = setInterval(() => {
      //   document.body.scrollTop = document.documentElement.scrollTop = top += 50
      //   if (top >= document.body.scrollTop) {
      //     clearInterval(timeTop)
      //   }
      // }, 10)
    },
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
    */
    goTop() {
      // window.scrollTo(0,  0)
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
  },
}
</script>

<style scoped>
#anchor{
  position: fixed;
  right: 20px;
  bottom: 150px;
  width: 50px;
  height: 239px;
  /*background-color: red;*/
  z-index: 111;
}
#anchor .anchor_item{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
  margin-top: 13px;
}
#anchor .anchor_item:nth-child(1){
  margin-top: 0;
}
#anchor .anchor_item > img{
  display: block;
  width: 28px;
  height: 28px;
}
#anchor .anchor_item .img1{
  display: block;
}
#anchor .anchor_item .img2{
  display: none;
}
#anchor .anchor_item:hover{
  background-color: #4E9BFF;
}
#anchor .anchor_item:hover .img1{
  display: none;
}
#anchor .anchor_item:hover .img2{
  display: block;
}
#anchor .anchor_item .tel{
  display: none;
  position: absolute;
  left: -143px;
  top: 5px;
  width: 129px;
  height: 60px;
  background: #4e9bff;
  border-radius: 10px;
  padding: 10px 14px;
  box-sizing: border-box;
}
#anchor .anchor_item .tel p{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: LEFT;
  color: #ffffff;
}
.arrow{
  position: absolute;
  right: -15px;
  top: 12px;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-left: 10px solid #4e9bff;
}
#anchor .anchor_item:hover .tel{
  display: block;
}
#anchor .anchor_item .download{
  display: none;
  position: absolute;
  left: -143px;
  top: 5px;
  width: 130px;
  background: #4e9bff;
  border-radius: 10px;
  padding: 10px 15px;
  box-sizing: border-box;
}
#anchor .anchor_item .download span{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  line-height: 20px;
}
#anchor .anchor_item .download .download_item{
  padding-top: 10px;
}
#anchor .anchor_item .download .download_item > img{
  display: none;
  width: 100px;
  height: 100px;
  margin-top: 6px;
}
#anchor .anchor_item .download .download_item:hover span{
  border-bottom: 1px solid #FFFFFF;
}
#anchor .anchor_item .download .download_item:hover > img{
  display: block;
}
#anchor .anchor_item:hover .download{
  display: block;
}
</style>